import React, { useEffect, useRef, useState } from 'react';

import _, { debounce } from 'lodash';
import {
  FormControl,
  IconButton,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  TextField,
  useMediaQuery,
  useTheme,
  Divider,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FilterIcon from '@material-ui/icons/FilterList';
import PropTypes from 'prop-types';
import { usePromoCode } from '../../../hook/usePromoCode';
import { IsEmpty } from '../../../common/checks';
import { Status } from '../../../common/constants';
import MText from '../../common/MText';

const promoCodeStatuses = [Status.Activated, Status.Deactivated, Status.Redeemed, Status.Unredeemed];

function Filter(props) {
  const { gifts, filter, onFilterChange, onResetFilter } = usePromoCode();

  const [localCode, setLocalCode] = useState('');
  const debouncedCodeFilter = useRef(
    debounce((value) => {
      onFilterChange({ code: value });

      if (!IsEmpty(props.onFilterChange)) {
        props.onFilterChange();
      }
    }, 500),
  ).current;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setLocalCode(value);
    debouncedCodeFilter(value);
  };

  const handleFilterChange = (params) => {
    onFilterChange(params);

    // The reason for adding this code is to allow us to clear all the selected rows in bulk update/delete modal
    if (!IsEmpty(props.onFilterChange)) {
      props.onFilterChange();
    }
  };

  useEffect(() => {
    setLocalCode(filter.code || '');
  }, [filter.code]);

  if (matches) {
    return (
      <div
        className="d-flex mt-3"
        style={{
          alignItems: 'end',
        }}
      >
        <TextField
          id="standard-basic"
          label="code"
          value={localCode}
          onChange={handleChange}
        />
        <FormControl className="mx-3" style={{ minWidth: 120 }}>
          <InputLabel id="demo-simple-select-label">Gift ID</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={filter.giftId}
            onChange={(e) => handleFilterChange({ giftId: e.target.value })}
          >
            {
              !IsEmpty(gifts) ? (
                _.map(gifts, (gift) => (
                  <MenuItem value={gift.id}>
                    {gift.label}
                    {' '}
                    -
                    {' '}
                    {gift.id}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
              )
            }
          </Select>
        </FormControl>
        <FormControl className="mr-3" style={{ minWidth: 120 }}>
          <InputLabel id="demo-simple-select-label">Status</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={filter.status}
            disabled={props.disableStatus}
            onChange={(e) => handleFilterChange({ status: e.target.value })}
          >
            {
              promoCodeStatuses.map((status) => (
                <MenuItem key={status} value={status}>{status}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
        <FormControl className="mr-3" style={{ minWidth: 120 }}>
          <MText className="mb-2">Created At</MText>
          <div className="d-flex flex-row" style={{ gap: 10 }}>
            <TextField
              label="Start"
              type="date"
              value={filter.createdAtStartRange}
              onChange={(e) => handleFilterChange({ createdAtStartRange: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End"
              type="date"
              value={filter.createdAtEndRange}
              onChange={(e) => handleFilterChange({ createdAtEndRange: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </FormControl>
        <FormControl className="mr-3" style={{ minWidth: 120 }}>
          <MText className="mb-2">Expiry Date</MText>
          <TextField
            label="Expiry Date"
            type="date"
            value={filter.expiryDate}
            onChange={(e) => handleFilterChange({ expiryDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
        <IconButton onClick={() => {
          onResetFilter(props.keepKeysUnchanged);

          if (!IsEmpty(props.onResetFilter)) {
            props.onResetFilter();
          }
        }}
        >
          <CloseIcon />
        </IconButton>
      </div>
    );
  }

  return (
    <div className="d-flex flex-row justify-content-end">
      <IconButton
        onClick={handleClick}
      >
        <FilterIcon color="black" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 240,
            width:     250,
          },
        }}
      >
        <MenuItem>
          <TextField
            id="standard-basic"
            label="code"
            value={localCode}
            onChange={handleChange}
          />
        </MenuItem>
        <MenuItem>
          <FormControl className="w-100">
            <InputLabel id="demo-simple-select-label">Gift ID</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filter.giftId}
              onChange={(e) => handleFilterChange({ giftId: e.target.value })}
            >
              {
                !IsEmpty(gifts) ? (
                _.map(gifts, (gift) => (
                  <MenuItem value={gift.id}>
                    {gift.label}
                    {' '}
                    -
                    {' '}
                    {gift.id}
                  </MenuItem>
                ))
                ) : (
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                )
              }
            </Select>
          </FormControl>
        </MenuItem>
        <MenuItem>
          <FormControl className="w-100">
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filter.status}
              disabled={props.disableStatus}
              onChange={(e) => handleFilterChange({ status: e.target.value })}
            >
              {
                promoCodeStatuses.map((status) => (
                  <MenuItem key={status} value={status}>{status}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </MenuItem>
        <Divider className="my-3" />
        <MenuItem>
          <MText>Created At</MText>
        </MenuItem>
        <MenuItem>
          <TextField
            label="Start"
            type="date"
            className="w-100"
            value={filter.createdAtStartRange}
            onChange={(e) => handleFilterChange({ createdAtStartRange: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
        </MenuItem>
        <MenuItem>
          <TextField
            label="End"
            type="date"
            className="w-100"
            value={filter.createdAtEndRange}
            onChange={(e) => handleFilterChange({ createdAtEndRange: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
        </MenuItem>
        <MenuItem>
          <MText>Expiry Date</MText>
        </MenuItem>
        <MenuItem>
          <TextField
            label="Expiry Date"
            type="date"
            className="w-100"
            value={filter.expiryDate}
            onChange={(e) => { handleFilterChange({ expiryDate: e.target.value }); }}
            InputLabelProps={{ shrink: true }}
          />
        </MenuItem>
        <MenuItem>
          <Button
            variant="contained"
            className="w-100"
            color="primary"
            onClick={() => {
              onResetFilter(props.keepKeysUnchanged);

              if (!IsEmpty(props.onResetFilter)) {
                props.onResetFilter();
              }

              setAnchorEl(null);
            }}
          >
            Clear
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
}

Filter.defaultProps = {
  disableStatus:     false,
  keepKeysUnchanged: [],
  onFilterChange:    () => {},
  onResetFilter:     () => {},
};

Filter.propTypes = {
  disableStatus:     PropTypes.bool,
  keepKeysUnchanged: PropTypes.arrayOf(PropTypes.string),
  onFilterChange:    PropTypes.func,
  onResetFilter:     PropTypes.func,
};

export default Filter;
